import { gql } from '@apollo/client';

export const ADD_OR_UPDATE_FEATURE_FLAGS_FOR_AUTH_DOMAIN = gql`
    mutation addOrUpdateFeatureFlagsForAuthDomain($input: AddOrUpdateFeatureFlagsForAuthDomainInput!) {
        system {
            authDomain {
                addOrUpdateFeatureFlags(input: $input) {
                    companyAlias
                    facilityAlias
                    featureFlags {
                        key
                        isEnabled
                        owner {
                            companyAlias
                            facilityAlias
                        }
                    }
                }
            }
        }
    }
`;
